import NextLink from '@/ui/NextLink';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';

export default function NavLink({ url, text, menu, variants, disabled, ...props }) {
  return (
    <motion.div className="group relative" variants={variants}>
      {disabled ? (
        <span className="flex cursor-pointer items-center gap-2 rounded-lg py-2 px-4 text-sm font-medium uppercase text-neutral-600 transition group-hover:text-primary-500 xl:text-lg">
          {text}
          {menu && <Icon className="opacity-50" icon="fluent:chevron-down-12-filled" />}
        </span>
      ) : (
        <NextLink activeClassName="!text-primary-500 bg-primary-500/10" href={url} {...props}>
          <a className="flex cursor-pointer items-center gap-2 rounded-lg py-2 px-4 text-sm font-medium uppercase text-neutral-600 transition focus:bg-primary-500/20 focus:text-primary-500 focus:outline-none group-hover:text-primary-500 xl:text-lg">
            {text}
            {menu && menu.length != 0 && (
              <Icon className="opacity-50" icon="fluent:chevron-down-12-filled" />
            )}
          </a>
        </NextLink>
      )}
      {menu && menu.length != 0 && (
        <div
          className="pointer-events-none absolute left-0 right-0 z-50 min-w-max -translate-y-4 opacity-0 transition duration-300 group-hover:pointer-events-auto group-hover:translate-y-0 group-hover:opacity-100"
          tabIndex="-1"
        >
          <div className="mt-2 flex flex-col rounded-lg bg-neutral-50 py-2 shadow-lg">
            {menu.map(({ url, text, ...props }, i) => (
              <NextLink
                key={i}
                activeClassName="text-white bg-primary-500 rounded-r-full"
                href={url}
                {...props}
              >
                <a
                  className="relative mr-2 overflow-hidden py-2 px-6 text-lg font-light transition duration-200 before:absolute before:inset-0 before:-translate-x-full before:rounded-r-full before:bg-primary-500 before:transition before:duration-300 before:content-[''] hover:text-white hover:before:translate-x-0 focus:before:bg-primary-600"
                  tabIndex="-1"
                >
                  <span className="relative">{text}</span>
                </a>
              </NextLink>
            ))}
          </div>
        </div>
      )}
    </motion.div>
  );
}
